module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2a"
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', [_vm._v("To my students:")])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("Their work inspires me with its creativity and originality. It is from them that I continue to learn new, improved methods and techniques to add to my repertoire, as well as gain an ever-increasing community of quilting friends.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d6dd37b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/dedication.vue
// module id = 69
// module chunks = 0